var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLifeSustainingTherapySmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09",
    "data-name": 9,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-10_4_",
    "data-name": "svgexport-10 (4)",
    transform: "translate(517.817 74.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10628",
    "data-name": "Group 10628",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12735",
    "data-name": "Path 12735",
    d: "M64.213,11.642l4.515-.379-.365-4.345L56.014,7.955l1.037,12.35L61.4,19.94l-.454-5.41A32.825,32.825,0,0,1,13.974,60.393,32.823,32.823,0,0,1,37.183,4.36V0A37.183,37.183,0,0,0,10.891,63.475,37.186,37.186,0,0,0,64.213,11.642Z",
    transform: "translate(0 0)",
    fill: "#ffe705"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_381",
    "data-name": "Ellipse 381",
    cx: 20.89,
    cy: 20.89,
    r: 20.89,
    transform: "translate(16.293 16.293)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12736",
    "data-name": "Path 12736",
    d: "M255.852,112.111v41.78a20.89,20.89,0,0,0,0-41.78Z",
    transform: "translate(-218.669 -95.818)",
    fill: "#eceae7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10622",
    "data-name": "Group 10622",
    transform: "translate(35.003 16.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12737",
    "data-name": "Path 12737",
    d: "M240.852,112.111h4.36v6.251h-4.36Z",
    transform: "translate(-240.852 -112.111)",
    fill: "#e7dfdd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12738",
    "data-name": "Path 12738",
    d: "M255.852,112.111h2.18v6.251h-2.18Z",
    transform: "translate(-218.669 -95.818)",
    fill: "#dad0cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10623",
    "data-name": "Group 10623",
    transform: "translate(35.003 51.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12739",
    "data-name": "Path 12739",
    d: "M240.852,356.579h4.36v6.251h-4.36Z",
    transform: "translate(-240.852 -356.579)",
    fill: "#e7dfdd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12740",
    "data-name": "Path 12740",
    d: "M255.852,356.579h2.18v6.251h-2.18Z",
    transform: "translate(-218.669 -304.757)",
    fill: "#dad0cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10624",
    "data-name": "Group 10624",
    transform: "translate(51.822 35.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12741",
    "data-name": "Path 12741",
    d: "M356.579,240.852h6.251v4.36h-6.251Z",
    transform: "translate(-356.579 -240.852)",
    fill: "#e7dfdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10625",
    "data-name": "Group 10625",
    transform: "translate(51.822 35.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12742",
    "data-name": "Path 12742",
    d: "M356.579,240.852h6.251v4.36h-6.251Z",
    transform: "translate(-356.579 -240.852)",
    fill: "#dad0cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10626",
    "data-name": "Group 10626",
    transform: "translate(16.293 35.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12743",
    "data-name": "Path 12743",
    d: "M112.111,240.852h6.251v4.36h-6.251Z",
    transform: "translate(-112.111 -240.852)",
    fill: "#e7dfdd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12744",
    "data-name": "Path 12744",
    d: "M120.182,143.252a23.07,23.07,0,1,1,23.07-23.07A23.1,23.1,0,0,1,120.182,143.252Zm0-41.78a18.71,18.71,0,1,0,18.71,18.71A18.731,18.731,0,0,0,120.182,101.472Z",
    transform: "translate(-82.999 -82.999)",
    fill: "#7dd5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12746",
    "data-name": "Path 12746",
    d: "M255.852,97.111v4.36a18.71,18.71,0,1,1,0,37.42v4.36a23.07,23.07,0,1,0,0-46.14Z",
    transform: "translate(-218.669 -82.998)",
    fill: "#6ba7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12748",
    "data-name": "Path 12748",
    d: "M282.882,52.33l4.515-.379-.365-4.345-12.35,1.036,1.037,12.35,4.345-.365-.454-5.41a32.825,32.825,0,0,1-23.758,55.475v4.36a37.188,37.188,0,0,0,27.03-62.723Z",
    transform: "translate(-218.669 -40.687)",
    fill: "#ecbe00"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(31.184 46.183)",
    fill: "#191919",
    fontSize: 24,
    fontFamily: "Outfit",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeSustainingTherapySmall);
export default __webpack_public_path__ + "static/media/lifeSustainingTherapy_small.bce35170291ba151f1d83a716275bc0b.svg";
export { ForwardRef as ReactComponent };